import { Box } from "@mui/material";
import { useRef } from "react";

import { useMap } from "../../contexts/MapContext";
import { useMapboxGeocoder } from "../../hooks/useMapboxGeocoder";

/**
 * A place search box that flies the map in MapContext, for a panel beside
 * the map rather than on top of it (the listing map's left edge belongs to
 * its layer pills).
 */
export default function PlaceSearch() {
  const { map } = useMap();
  const mapRef = useRef(map);
  mapRef.current = map;
  const { geocoderContainerRef } = useMapboxGeocoder(mapRef, !!map);

  return (
    <Box
      ref={geocoderContainerRef}
      sx={{
        // The geocoder sizes itself for a map corner; fill the panel instead.
        "& .mapboxgl-ctrl-geocoder": {
          width: "100%",
          maxWidth: "none",
          boxShadow: "none",
          border: "1px solid #e0e0e0",
          borderRadius: 1,
        },
      }}
    />
  );
}
